/**
 * Team Updates config — used by the Team Updates pillar.
 *
 * Each team has a default DRI (the person whose update we expect to see
 * by Monday). DRI can be overridden per-entry when the team explicitly
 * reassigns it; if a team-update save doesn't include a DRI, the server
 * merges with the existing value so the DRI sticks.
 *
 * Data shape for a single team's entry, stored at
 *   meta.teamUpdates[teamId]:
 *     {
 *       tldr:    string,
 *       wins:    string,
 *       flags:   string,     // blockers / risks / flags
 *       dri:     string,     // owner of this week's team update
 *       savedAt: number,     // Date.now() of last save
 *       savedBy: string,     // user who wrote the update
 *     }
 *
 * Marketing was intentionally omitted — the GTM team covers marketing-
 * adjacent work for Q2 2026. Add a `marketing` team here when/if the
 * function has its own DRI.
 */
export const TEAMS = [
  {
    id: 'gtm',
    name: 'GTM',
    icon: '🎯',
    color: '#16a34a',
    defaultDri: 'Christina',
    description: 'Sales, partnerships, pipeline, and customer-facing motion.',
  },
  {
    id: 'delivery',
    name: 'Delivery',
    icon: '🚀',
    color: '#2563eb',
    defaultDri: 'Katie',
    description: 'Customer delivery, buyout execution, and client success.',
  },
  {
    id: 'product',
    name: 'Product',
    icon: '💡',
    color: '#d97706',
    defaultDri: 'Margo',
    description: 'Product strategy, roadmap, and shipped features.',
  },
]

export function teamById(id) {
  return TEAMS.find((t) => t.id === id) || null
}
